import Rails from "@rails/ujs"
import "../stylesheets/mobile.scss"
import "../inventory_documents"
import { showFlashToasts } from "../mobile/toast"
import { initCounts } from "../mobile/counts"
import { initDelivery } from "../mobile/delivery"
import { initKeyboardAwareBottomBar, keepFocusedFieldVisible } from "../mobile/keyboard"

// El pack `application` ya arranca @rails/ujs; si algún día una página mezcla
// ambos packs, esto evita el doble Rails.start() (lanza excepción).
if (!window._railsStarted) {
  Rails.start()
  window._railsStarted = true
}

document.addEventListener("DOMContentLoaded", () => {
  showFlashToasts()
  initCounts()
  initDelivery()
  initKeyboardAwareBottomBar()
  keepFocusedFieldVisible()

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Instalación PWA no crítica: si falla, la app sigue funcionando igual.
    })
  }
})
import "../app_experience"
